import {HttpContextToken} from '@angular/common/http';

export class TenantContext {
  constructor(public readonly enabled: boolean,
              public readonly includeSubtenants: boolean,
              public readonly tenant?: string) {
  }
}

export const TENANT_CONTEXT = new HttpContextToken<TenantContext>(() => new TenantContext(false, false));
